import { FC } from "react";

import {
  EditFormMode,
  IRideDto,
  Log,
  onActivateKeyDown,
  useDrawers,
} from "@ryde/shared";

interface IRideOpenStationRouteLink {
  stationRouteIds: number[] | undefined;
  /** When set (ride form), drawer gets rideOpenerId for exclude/reactivate controls. */
  rideDto?: Partial<IRideDto> | undefined;
}

export const RideOpenStationRouteLink: FC<IRideOpenStationRouteLink> = ({
  stationRouteIds,
  rideDto,
}) => {
  const { openStationRouteEditFormDrawer } = useDrawers();

  const handleStationRouteClick = async (
    stationRouteId: number,
  ): Promise<void> => {
    const result = await openStationRouteEditFormDrawer({
      id: stationRouteId,
      rideOpenerId: rideDto?.id,
      mode: EditFormMode.UnboundDrawer,
    });

    if (result.success) {
      Log.debug("Station route updated");
    }
  };

  if (!stationRouteIds?.length) {
    return null;
  }

  return (
    <>
      {stationRouteIds.map((stationRouteId, index) => (
        <span key={stationRouteId}>
          <span
            className="link_clickable"
            role="button"
            tabIndex={0}
            onClick={() => handleStationRouteClick(stationRouteId)}
            onKeyDown={onActivateKeyDown(() =>
              handleStationRouteClick(stationRouteId),
            )}
          >
            {stationRouteId}
          </span>
          {index < stationRouteIds.length - 1 && ", "}
        </span>
      ))}
    </>
  );
};
